module.exports = __webpack_public_path__ + "static/media/poster-mixing-times.94b00222.pdf";